export const scheduleTaxonomyStructureRefresh = ({event, schedule}) => {
    if (!event.detail?.scopes?.includes('taxonomy')) return false;

    const refresh = new Promise((resolve, reject) => schedule(outcome => {
        if (outcome?.disposed) resolve({disposed: true});
        else if (outcome?.ok === false) reject(outcome.error || new Error('Taxonomy refresh was canceled'));
        else resolve(outcome?.result);
    }));
    event.detail?.waitUntil?.(refresh, ['taxonomy']);
    return true;
};
